<template>
        <div class="popup visible" id="history-updates-popup" @click.stop="">
            <div class="max-w-content">
                <p class="box-title center">История обновлений</p>
                <ul class="history-updates-list">
                    <li v-for="(version,index) in getVersions" :key="index">
                        <time :datetime="version.date" class="time">
                            {{version.date}}
                        </time>
                        <p>{{version.text}}</p>
                        <a href class="go-to" @click.prevent="handleClick(version.id)">Перейти к публикации</a>
                    </li>
                </ul>
                <span class="js-close-popup" title="Закрыть" @click="$emit('close')">
                    <icon-base width="14" height="14" view-box="0 0 14 14" icon-name="Закрыть"><icon-close/></icon-base>
                </span>
            </div>
        </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import IconBase from "../common/IconBase";
    import IconClose from "../common/icons/IconClose";

    export default {
        name: 'post-versions-component',
        components: {
            IconBase,
            IconClose
        },
        computed: {
            ...mapGetters('knowledge', [
                'getVersions'
            ]),
        },
        methods: {
            ...mapActions('knowledge', [
                'getPost'
            ]),
            ...mapActions([
                'switchPopup'
            ]),
            handleClick(id) {
                //this.getPost({id: id, revision: true}).then(() => {
                    this.$router.push({name: 'knowledge-base-archive', params: {id: id}});
                    this.switchPopup(false)
                //})
            }
        }
    }
</script>


<style scoped>

</style>
